import React from 'react';
import { RefreshCwIcon, TrashIcon, PlusIcon, EditIcon } from 'lucide-react';
const IntentLibrary: React.FC = () => {
  const productIntents = [{
    id: 1,
    product: 'Animal Shelter Volunteering',
    intents: ['I want to help animals in need', 'Looking for pet adoption centers', 'Where can I volunteer with dogs and cats', 'Wish I could spend time with shelter animals', 'Want to help at an animal rescue']
  }, {
    id: 2,
    product: 'Food Bank Assistance',
    intents: ['Want to help feed the homeless', 'Food bank volunteer opportunities', 'How to donate food to those in need', 'Feeling sad about food insecurity', 'Want to help with hunger issues']
  }, {
    id: 3,
    product: 'Literacy Programs',
    intents: ['How to help kids learn to read', 'Volunteer as a reading tutor', 'Literacy volunteer opportunities', 'Want to help with education', 'Reading mentorship programs']
  }, {
    id: 4,
    product: 'Beach Cleanup',
    intents: ['Ocean pollution is terrible', 'Want to help clean up beaches', 'Environmental volunteer opportunities', 'Sad about plastic in the ocean', 'How to help with marine conservation']
  }, {
    id: 5,
    product: 'Hospital Volunteering',
    intents: ['How to volunteer at hospitals', 'Want to help patients', 'Healthcare volunteer opportunities', 'Looking for ways to support healthcare workers', 'Hospital visitor program']
  }];
  return <div className="bg-gray-800 rounded-lg" data-id="element-152">
      <div className="p-4 border-b border-gray-700 flex justify-between items-center" data-id="element-153">
        <h2 className="text-xl font-semibold" data-id="element-154">Intent Library</h2>
        <button className="text-xs bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded flex items-center gap-1" data-id="element-155">
          <PlusIcon className="w-4 h-4" data-id="element-156" /> Add Activity
        </button>
      </div>
      <div className="p-4 space-y-6" data-id="element-157">
        {productIntents.map(item => <div key={item.id} className="bg-gray-700 rounded-lg overflow-hidden" data-id="element-158">
            <div className="p-3 bg-gray-600 flex justify-between items-center" data-id="element-159">
              <h3 className="font-medium" data-id="element-160">{item.product}</h3>
              <div className="flex gap-2" data-id="element-161">
                <button className="p-1 hover:bg-gray-500 rounded" data-id="element-162">
                  <EditIcon className="w-4 h-4" data-id="element-163" />
                </button>
                <button className="p-1 hover:bg-gray-500 rounded" data-id="element-164">
                  <RefreshCwIcon className="w-4 h-4" data-id="element-165" />
                </button>
              </div>
            </div>
            <div className="p-3" data-id="element-166">
              <table className="w-full text-sm" data-id="element-167">
                <thead className="text-left text-gray-400" data-id="element-168">
                  <tr data-id="element-169">
                    <th className="pb-2 font-normal" data-id="element-170">Intent Phrase</th>
                    <th className="pb-2 font-normal w-24" data-id="element-171">Actions</th>
                  </tr>
                </thead>
                <tbody data-id="element-172">
                  {item.intents.map((intent, index) => <tr key={index} className="border-t border-gray-600" data-id="element-173">
                      <td className="py-2" data-id="element-174">{intent}</td>
                      <td className="py-2" data-id="element-175">
                        <div className="flex gap-2" data-id="element-176">
                          <button className="p-1 hover:bg-gray-600 rounded" data-id="element-177">
                            <EditIcon className="w-4 h-4" data-id="element-178" />
                          </button>
                          <button className="p-1 hover:bg-gray-600 rounded text-red-400" data-id="element-179">
                            <TrashIcon className="w-4 h-4" data-id="element-180" />
                          </button>
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
              <button className="mt-3 text-xs bg-gray-600 hover:bg-gray-500 px-3 py-1 rounded flex items-center gap-1 w-full justify-center" data-id="element-181">
                <RefreshCwIcon className="w-3 h-3" data-id="element-182" /> Regenerate All Intents
              </button>
            </div>
          </div>)}
      </div>
    </div>;
};
export default IntentLibrary;